export enum Operator {
  EQ = 'EQ',
  NE = 'NE',
  LT = 'LT',
  LE = 'LE',
  GT = 'GT',
  GE = 'GE',
  IN = 'IN',
  NI = 'NI',
  SEARCH = 'SEARCH',
  OR = 'OR',
}

export interface Filter<T = unknown> {
  field?: keyof T | string;
  operator: Operator;
  value: any,
}

interface Sort<T = unknown> {
  field: keyof T;
  desc: boolean;
}

interface Fetch {
  fetch: string;
}

interface Offset {
  offset: number;
}

interface Limit {
  limit: number;
}

function isSort(arg: any): arg is Sort {
  return arg.desc !== undefined;
}

function isFilter(arg: any): arg is Filter {
  return arg.operator !== undefined;
}

function isFetch(arg: any): arg is Fetch {
  return arg.fetch !== undefined;
}

function isOffset(arg: any): arg is Offset {
  return arg.offset !== undefined;
}

function isLimit(arg: any): arg is Limit {
  return arg.limit !== undefined;
}

export type Query<T = unknown> = Filter<T> | Sort<T> | Fetch | Offset | Limit;

/**
 *
 * @template T: Resource Type
 * @param {...Query<T>[]} criteria: Predicates
 * @example
 * composeQuery<Organization>(
 *   { field: 'id', operator: Operator.GT, value: '10' },
 *   { field: 'name', desc: true },
 *   { fetch: 'user'},
 *   { limit: 10 },
 *   { offset: 20 },
 * )
 *
 */
export const composeQuery = <T>(...criteria: Query<T>[]) => ({
  query: JSON.stringify({
    filters: criteria.filter(isFilter),
    sorts: criteria.filter(isSort),
    fetches: criteria.filter(isFetch).map(arg => arg.fetch),
    ...{
      offset: criteria.filter(isOffset).map(arg => arg.offset)?.[0] ?? undefined,
      limit: criteria.filter(isLimit).map(arg => arg.limit)?.[0] ?? undefined,
    },
  }),
});
